import styled from "styled-components";

interface IBannerImageProps {

    url: string;

}

const ZoneView = styled.div`
    width: 100.0000vw;
   // object-fit: contain;  
`

export default function BannerImage({ url }: IBannerImageProps) {

    return (
        <ZoneView>
            <img src={url} width="100%" alt="" />
        </ZoneView>
    );

}